const updateAreasStr = {
  toastrSuccess: 'Updated department',
  toastrSuccess2: ' has been updated successfully',
  toastrError: 'Department already registered',
  toastrError1: 'Enter another name'
};

export default updateAreasStr;
